import { COLORS } from 'helpers/globals'

const line = {
  padding: '.3rem 0',
  transition: 'width 200ms, background 200ms',
  borderRadius: '.5rem 0 0 .5rem'
}

export default {
  container: {
    maxHeight: '80vh',
    height: '80vh',
    display: 'grid',
    gridTemplateRows: 'repeat(5, auto)',
    gridTemplateColumns: '150px',
    gridAutoColumns: 'minmax(290px, calc((100% - 150px - 4 * 1.5rem) / 4))',
    gridAutoFlow: 'column',
    gap: '1rem 1.5rem',
    overflow: 'auto',
    padding: '.5rem .5rem .5rem 0',
    overscrollBehavior: 'none'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    position: 'sticky',
    left: 0,
    zIndex: 3,
    gridColumn: 1
  },
  lineWrapper: {
    flexWrap: 'wrap',
    display: 'flex',
    margin: '0 1rem',
    fontSize: '1.4rem'
  },
  bubble: {
    borderRadius: '1rem',
    border: '1px solid black',
    marginTop: '1rem',
    width: '100%'
  },
  line: {
    ...line,
    background: COLORS.primary,
    '&.full': {
      background: COLORS.green,
      borderRadius: '.5rem'
    }
  },
  totalLine: {
    ...line,
    background: '#bcbcbc',
    '&.full': {
      background: '#969696',
      borderRadius: '.5rem'
    }
  },
  totalLabel: {
    flex: 1,
    color: COLORS.secondary
  },
  helpIcon: {
    marginLeft: '.5rem'
  },
  headerBackground: {
    gridRow: '1 / -1',
    gridColumn: 1,
    zIndex: 2,
    marginTop: '-5px',
    background: 'white',
    position: 'sticky',
    left: 0,
    boxShadow: `3px 0 2px -2px ${COLORS.quaternary}`
  },
  newDoorButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1rem',
    cursor: 'pointer',
    overflowX: 'hidden',
    gridRow: '1 / -1',
    position: 'sticky',
    top: 0,
    maxHeight: 'calc(80vh - 1rem)',
    fontSize: '2rem',
    fontWeight: 400,
    color: COLORS.primary,
    boxShadow: `0 0 2px 1px ${COLORS.quaternary}`,
    transition: 'box-shadow 200ms, color 200ms',
    '& svg.fa-inverse': { color: 'white' },
    '&:hover': {
      color: COLORS.primaryHover,
      boxShadow: `0 0 4px 1px ${COLORS.primaryHover}`
    },
    '&.disabled': {
      color: COLORS.secondary,
      cursor: 'not-allowed',
      '&:hover': {
        color: COLORS.secondary,
        boxShadow: `0 0 2px 1px ${COLORS.secondary}`
      }
    },
    '&.shrunk': {
      width: '150px'
    }
  },
  warningText: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.6rem',
    fontWeight: 300,
    color: COLORS.secondary,
    padding: '1rem .5rem 0 .5rem',
    lineHeight: '2rem'
  },
  warningIcon: {
    marginRight: '.5rem',
    color: COLORS.warning
  },
  fadeAppear: {
    opacity: 0,
    width: '0 !important'
  },
  fadeAppearActive: {
    opacity: 1,
    width: '350px !important',
    transition: 'opacity 200ms, width 200ms'
  },
  fadeAppearDone: {
    width: '350px !important',
  },
  fadeEnter: {
    opacity: 0,
    width: '0 !important',
    transition: 'opacity 200ms, width 200ms'
  },
  fadeEnterActive: {
    opacity: 1,
    width: '350px !important',
    transition: 'opacity 200ms, width 200ms'
  },
  fadeEnterDone: {
    width: '350px !important',
  },
  fadeExit: {
    opacity: 1,
    width: '350px !important'
  },
  fadeExitActive: {
    opacity: 0,
    width: '0 !important',
    transition: 'opacity 200ms, width 200ms'
  },
  fadeExitDone: {
    width: '0 !important',
    opacity: 0
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/style.js